// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-container,
.media-upload-gallery-container {
  -webkit-user-select: none;
          user-select: none;
}
.gallery-container .ant-row,
.media-upload-gallery-container .ant-row {
  width: 100%;
}
.gallery-container .ant-row .ant-col,
.media-upload-gallery-container .ant-row .ant-col {
  max-width: 200px;
  width: 100%;
}
.gallery-container .ant-row .ant-col .folder,
.media-upload-gallery-container .ant-row .ant-col .folder {
  cursor: pointer;
  border-color: transparent;
}
.gallery-container .ant-row .ant-col .folder:hover,
.media-upload-gallery-container .ant-row .ant-col .folder:hover {
  background-color: var(--grey);
}
.gallery-container .ant-row .ant-col .ant-card,
.media-upload-gallery-container .ant-row .ant-col .ant-card {
  background: transparent;
  border-radius: 7px;
  padding: 5px;
  height: 180px;
  text-align: center;
  transition: box-shadow 0.5s ease-out;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}
.gallery-container .ant-row .ant-col .ant-card:hover,
.media-upload-gallery-container .ant-row .ant-col .ant-card:hover {
  transition: box-shadow 0.5s ease-out;
}
.gallery-container .ant-row .ant-col .ant-card .ant-card-body,
.media-upload-gallery-container .ant-row .ant-col .ant-card .ant-card-body {
  padding: 0 !important;
}
.gallery-container .ant-row .ant-col .ant-card .icon-folder,
.media-upload-gallery-container .ant-row .ant-col .ant-card .icon-folder {
  width: 130px;
  height: 100%;
  background: none;
}
.gallery-container .ant-row .ant-col .ant-card .ant-card-head,
.media-upload-gallery-container .ant-row .ant-col .ant-card .ant-card-head {
  min-height: 0;
}
.gallery-container .ant-row .ant-col .ant-card .ant-card-head .ant-card-head-wrapper .ant-card-head-title,
.media-upload-gallery-container .ant-row .ant-col .ant-card .ant-card-head .ant-card-head-wrapper .ant-card-head-title {
  padding: 0;
}

.upload-media .ant-upload.ant-upload-select-picture-card {
  width: 100% !important;
  height: 250px !important;
}

.media-upload-gallery-container {
  background-color: transparent !important;
}

.icon-center-delete {
  position: absolute !important;
  top: 0px;
  right: 10px;
  padding: 0;
}

.card-image {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px !important;
}

[data-theme=dark] .gallery-container .ant-row .ant-col .folder:hover {
  background-color: var(--dark-blue);
}

.gallery-item .ant-card {
  background: transparent !important;
}
.gallery-item .ant-card-body .ant-card-body {
  padding: 0;
}
.gallery-item .ant-image {
  width: 200px;
  height: 200px;
  object-fit: cover;
  overflow: hidden;
  border-radius: 8px;
}
.gallery-item .ant-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  transition: all ease 300ms;
}
.gallery-item .ant-image img:hover {
  transform: scale(1.05);
}

.media-upload-wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.media-upload-wrapper .ant-image {
  width: 110px;
  height: 110px;
  border-radius: 10px;
  padding: 8px;
  border: 1px solid #4d5b75;
  cursor: pointer;
}
.media-upload-wrapper .ant-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.media-upload-wrapper .image-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.media-upload-wrapper .image-wrapper::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 10px;
  transition: all ease 300ms;
  background: rgba(0, 0, 0, 0);
}
.media-upload-wrapper .image-wrapper:hover::after {
  background: rgba(0, 0, 0, 0.3);
}
.media-upload-wrapper .image-wrapper .anticon-delete {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  transition: all ease 300ms;
  color: white !important;
}
.media-upload-wrapper .image-wrapper .anticon-delete svg {
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: white !important;
}
.media-upload-wrapper .image-wrapper:hover .anticon-delete {
  visibility: visible;
  opacity: 1;
  color: white !important;
}
.media-upload-wrapper .image-wrapper:hover .anticon-delete svg {
  color: white !important;
}

.media-upload-wrapper-wider .ant-image {
  width: 220px;
  height: 110px;
}

.media-upload {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 8px;
  width: 110px;
  height: 110px;
  border: 2px dashed #4d5b75;
  border-radius: 10px;
  background-color: transparent;
  cursor: pointer;
  transition: all ease 300ms;
}
.media-upload:hover {
  border: 2px dashed var(--primary);
}

.media-upload-wider {
  width: 220px;
  height: 110px;
}

.antdImgUpload .ant-upload div {
  font-size: 25px !important;
}
.antdImgUpload .anticon {
  font-size: 50px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/gallery.scss"],"names":[],"mappings":"AAAA;;EAEE,yBAAA;UAAA,iBAAA;AACF;AACE;;EACE,WAAA;AAEJ;AAAI;;EACE,gBAAA;EACA,WAAA;AAGN;AADM;;EACE,eAAA;EACA,yBAAA;AAIR;AAHQ;;EACE,6BAAA;AAMV;AAFM;;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAKR;AAHQ;;EACE,oCAAA;AAMV;AAJQ;;EACE,qBAAA;AAOV;AALQ;;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AAQV;AANQ;;EACE,aAAA;AASV;AANY;;EACE,UAAA;AASd;;AAEI;EACE,sBAAA;EACA,wBAAA;AACN;;AAIA;EACE,wCAAA;AADF;;AAIA;EACE,6BAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;AADF;;AAOM;EACE,kCAAA;AAJR;;AAWE;EACE,kCAAA;AARJ;AAYI;EACE,UAAA;AAVN;AAcE;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAZJ;AAcI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EAEA,eAAA;EACA,0BAAA;AAbN;AAeM;EACE,sBAAA;AAbR;;AAmBA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;AAhBF;AAkBE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;AAhBJ;AAkBI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAhBN;AAoBE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAlBJ;AAoBI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;EACA,0BAAA;EACA,4BAAA;AAlBN;AAsBM;EACE,8BAAA;AApBR;AAwBI;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,0BAAA;EACA,uBAAA;AAtBN;AAuBM;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;AArBR;AA0BM;EACE,mBAAA;EACA,UAAA;EACA,uBAAA;AAxBR;AAyBQ;EACE,uBAAA;AAvBV;;AA+BE;EACE,YAAA;EACA,aAAA;AA5BJ;;AAgCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,0BAAA;AA7BF;AA+BE;EACE,iCAAA;AA7BJ;;AAgCA;EACE,YAAA;EACA,aAAA;AA7BF;;AAiCI;EACE,0BAAA;AA9BN;AAiCE;EACE,0BAAA;AA/BJ","sourcesContent":[".gallery-container,\n.media-upload-gallery-container {\n  user-select: none;\n\n  .ant-row {\n    width: 100%;\n\n    .ant-col {\n      max-width: 200px;\n      width: 100%;\n\n      .folder {\n        cursor: pointer;\n        border-color: transparent;\n        &:hover {\n          background-color: var(--grey);\n        }\n      }\n\n      .ant-card {\n        background: transparent;\n        border-radius: 7px;\n        padding: 5px;\n        height: 180px;\n        text-align: center;\n        transition: box-shadow 0.5s ease-out;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: row;\n        flex-wrap: wrap;\n\n        &:hover {\n          transition: box-shadow 0.5s ease-out;\n        }\n        .ant-card-body {\n          padding: 0 !important;\n        }\n        .icon-folder {\n          width: 130px;\n          height: 100%;\n          background: none;\n        }\n        .ant-card-head {\n          min-height: 0;\n\n          .ant-card-head-wrapper {\n            .ant-card-head-title {\n              padding: 0;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.upload-media {\n  .ant-upload {\n    &.ant-upload-select-picture-card {\n      width: 100% !important;\n      height: 250px !important;\n    }\n  }\n}\n\n.media-upload-gallery-container {\n  background-color: transparent !important;\n}\n\n.icon-center-delete {\n  position: absolute !important;\n  top: 0px;\n  right: 10px;\n  padding: 0;\n}\n\n.card-image {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px !important;\n}\n\n[data-theme='dark'] .gallery-container {\n  .ant-row {\n    .ant-col {\n      .folder:hover {\n        background-color: var(--dark-blue);\n      }\n    }\n  }\n}\n\n.gallery-item {\n  .ant-card {\n    background: transparent !important;\n  }\n\n  .ant-card-body {\n    .ant-card-body {\n      padding: 0;\n    }\n  }\n\n  .ant-image {\n    width: 200px;\n    height: 200px;\n    object-fit: cover;\n    overflow: hidden;\n    border-radius: 8px;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n\n      cursor: pointer;\n      transition: all ease 300ms;\n\n      &:hover {\n        transform: scale(1.05);\n      }\n    }\n  }\n}\n\n.media-upload-wrapper {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n\n  .ant-image {\n    width: 110px;\n    height: 110px;\n    border-radius: 10px;\n    padding: 8px;\n    border: 1px solid #4d5b75;\n    cursor: pointer;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n  }\n\n  .image-wrapper {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n\n    &::after {\n      content: '';\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n      border-radius: 10px;\n      transition: all ease 300ms;\n      background: rgba($color: #000000, $alpha: 0);\n    }\n\n    &:hover {\n      &::after {\n        background: rgba($color: #000000, $alpha: 0.3);\n      }\n    }\n\n    .anticon-delete {\n      position: absolute;\n      visibility: hidden;\n      opacity: 0;\n      transition: all ease 300ms;\n      color: white !important;\n      svg {\n        width: 24px;\n        height: 24px;\n        cursor: pointer;\n        color: white !important;\n      }\n    }\n\n    &:hover {\n      .anticon-delete {\n        visibility: visible;\n        opacity: 1;\n        color: white !important;\n        svg {\n          color: white !important;\n        }\n      }\n    }\n  }\n}\n\n.media-upload-wrapper-wider {\n  .ant-image {\n    width: 220px;\n    height: 110px;\n  }\n}\n\n.media-upload {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 8px;\n  width: 110px;\n  height: 110px;\n  border: 2px dashed #4d5b75;\n  border-radius: 10px;\n  background-color: transparent;\n  cursor: pointer;\n  transition: all ease 300ms;\n\n  &:hover {\n    border: 2px dashed var(--primary);\n  }\n}\n.media-upload-wider {\n  width: 220px;\n  height: 110px;\n}\n.antdImgUpload {\n  .ant-upload {\n    div {\n      font-size: 25px !important;\n    }\n  }\n  .anticon {\n    font-size: 50px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
